function Reports() {
  return (
    <>
      <div className="layout-content">
        <h1>Hi</h1>
      </div>
    </>
  );
}

export default Reports;
